import styled from "@emotion/styled"
import { breakpoints, dimensions, theme } from "../../../utils/styles"

export const Section = styled.section`
  background: ${({ theme }) => theme.black};
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 32px;

  @media (max-width: ${breakpoints.l}px) {
    padding: 48px 24px;
  }
`

export const Container = styled.div`
  width: 100%;
  max-width: ${dimensions.contentWidth};
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;
`

export const Eyebrow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${theme.primary};
  white-space: nowrap;

  &::before {
    content: "";
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: ${theme.primary};
  }
`

export const CategoryTabs = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
`

export const CategoryButton = styled.button`
  font-family: Nunito, sans-serif;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.03em;
  padding: 10px 24px;
  border-radius: 999px;
  border: 1.5px solid ${theme.primary};
  background: ${({ active }) => (active ? theme.primary : "transparent")};
  color: ${({ active }) => (active ? theme.black : theme.white)};
  cursor: pointer;
  transition: background 0.25s ease, color 0.25s ease, transform 0.25s ease;

  &:hover {
    background: ${theme.primary};
    color: ${theme.black};
    transform: translateY(-2px);
  }
`

export const LogoRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 40px;
  padding: 56px 0 16px;
`

export const LogoTile = styled.a`
  display: flex;
  align-items: center;
  opacity: 0.85;
  text-decoration: none;
  transition: opacity 0.25s ease;

  &:hover {
    opacity: 1;
  }
`

export const LogoImage = styled.img`
  height: 64px;
  width: auto;
  margin: 0;

  @media (max-width: ${breakpoints.l}px) {
    height: 48px;
  }
`

export const EmptyState = styled.p`
  color: ${theme.muted};
  font-size: 15px;
  padding: 40px 0 16px;
  margin: 0;
`
